import {
    Component,
    OnInit,
    Output,
    EventEmitter,
    OnDestroy,
} from '@angular/core';
import { ContextDossier } from '@kv-common-components/kv-common-components';
import {
    AuthenticationService,
    DocumentGed,
    EspaceClientService,
    EspaceDocumentaireService,
} from '@kv-common-components/kx-services';
import { modalAnimations } from '@shared/animations/animations';
import { FormatHelperService } from '@shared/services/format-helper.service';
import * as moment from 'moment';
import { Subscription } from 'rxjs';

@Component({
    /* eslint-disable-next-line @angular-eslint/component-selector */
    selector: '[appHeaderDocuments]',
    templateUrl: './header-documents.component.html',
    styleUrls: ['header-documents.component.scss'],
    animations: modalAnimations,
})
export class HeaderDocumentsComponent implements OnInit, OnDestroy {
    @Output() toggleRightMenuMobile = new EventEmitter<boolean>();
    @Output() toggleDocuments = new EventEmitter<boolean>();
    espaceDocVisibility = false;
    currentEspaceClient: any;
    isLoggedIn = false;
    contextDossier: ContextDossier;
    idProjet: any;
    codeProduit: any;
    page = 'CONTRACTUAL_DOCUMENT';

    docTypes = ['CONTRACTUAL_DOCUMENT', 'INFO_DOCUMENT', 'MEDICAL_DOCUMENT'];
    allDocuments: DocumentGed[];
    idDossier: string;
    idPersonne: string;
    idPropositionPrincipale: string;
    listeProjectCredit: any;
    contextDossierArray = [];
    headerTab: any;
    selectedContextDossier: any;
    selectedItem = false;
    showDocNav: boolean;

    espaceClientSubscription: Subscription;
    userSubscription: Subscription;

    constructor(
        private espaceDocumentaireService: EspaceDocumentaireService,
        private espaceClientService: EspaceClientService,
        private authenticationService: AuthenticationService
    ) {
        // TODO replace with common components
    }

    ngOnInit(): void {
        this.espaceClientSubscription =
            this.espaceClientService.currentEspaceClient.subscribe((data) => {
                this.currentEspaceClient = data;
                this.contextDossierArray = [];
                this.idPersonne =
                    this.authenticationService.currentUserValue.idPersonne;
                // build an Array of contextDossier
                if (
                    this.currentEspaceClient.listeProjetsCredits &&
                    this.currentEspaceClient.listeProjetsCredits.length > 0
                ) {
                    for (const itemByDossier of this.currentEspaceClient
                        .listeProjetsCredits) {
                        this.contextDossier =
                            ContextDossier.initContextDossierFromEspaceClient(
                                this.idPersonne,
                                itemByDossier.idProjetCredit.toString(),
                                this.currentEspaceClient
                            );
                        FormatHelperService.checkAssurance(this.contextDossier);
                        this.contextDossierArray.push(this.contextDossier);
                    }
                    this.contextDossierArray.sort((dossierA, dossierB) =>
                        moment(dossierB.emprunteur.dateEffet).diff(
                            moment(dossierA.emprunteur.dateEffet)
                        )
                    );
                    // load the first contextDossier from the array
                    this.headerTab =
                        this.contextDossierArray[0].dossier.idProjetCredit;
                    this.loadEspaceDocByIdDossier(this.contextDossierArray[0]);
                    this.showDocNav = true;
                } else {
                    this.showDocNav = false;
                }
            });

        this.userSubscription =
            this.authenticationService.currentUser.subscribe((response) => {
                this.isLoggedIn = !!response;
            });
    }

    ngOnDestroy() {
        if (this.espaceClientSubscription) {
            this.espaceClientSubscription.unsubscribe();
        }
        if (this.userSubscription) {
            this.userSubscription.unsubscribe();
        }
    }

    toggleMobileRightMenu() {
        this.toggleRightMenuMobile.emit();
    }

    switchToOtherTab(page) {
        this.page = page;
    }

    loadEspaceDocByIdDossier(itemContextDossier: any) {
        this.headerTab = itemContextDossier.dossier.idProjetCredit;
        this.selectedContextDossier = itemContextDossier;
        this.espaceDocContent(
            itemContextDossier.emprunteur.assurance.idPropositionPrincipale
        );
    }

    resetSelection(value: boolean) {
        this.selectedItem = value;
    }

    espaceDocContent(idPropositionPrincipale) {
        this.espaceDocumentaireService
            .getEspaceDocumentaire(this.idPersonne, idPropositionPrincipale)
            .subscribe((results) => {
                this.allDocuments = results;
            });
    }

    loadEspaceDocByIdDossierMobile(itemContextDossier: any) {
        this.selectedItem = !this.selectedItem;
        this.loadEspaceDocByIdDossier(itemContextDossier);
    }

    loadEspaceDoc() {
        this.loadEspaceDocByIdDossier(this.contextDossierArray[0]);
        this.espaceDocVisibility = !this.espaceDocVisibility;
    }
}
